import React from 'react';
import S from './StyledPageHeaderTitle';

const PageHeaderTitle = ({text}) => {
    return (
        <S.PageHeaderTitleWrapper>
            <S.PageHeaderTitleBackground/>
            <S.Title>{text}</S.Title>
        </S.PageHeaderTitleWrapper>
     );
}
 
export default PageHeaderTitle;